import { FC, ReactNode } from "react";
import { VoucherCard } from "dds4/components/VoucherCard/v1/VoucherCard";
import { getCssVar } from "src/utility";

const HEIGHT = 144;
const MAIN_WIDTH = 208;
const STUB_WIDTH = 80;
const NOTCH_RADIUS = 10;

type HeroVoucherProps = {
  label: ReactNode;
  title: ReactNode;
  subtitle: ReactNode;
  stub: ReactNode;
};

const HeroVoucher: FC<HeroVoucherProps> = ({ label, title, subtitle, stub }) => {
  return (
    <div className="flex drop-shadow-lg">
      <VoucherCard
        fillColor="var(--color-background-primary)"
        borderStyle="none"
        borderRadius={12}
        notches={[
          { position: { x: MAIN_WIDTH, y: 0 }, radius: NOTCH_RADIUS },
          { position: { x: MAIN_WIDTH, y: HEIGHT }, radius: NOTCH_RADIUS },
        ]}
        lines={(w, h) => [
          {
            from: { x: w, y: NOTCH_RADIUS + 4 },
            to: { x: w, y: h - NOTCH_RADIUS - 4 },
            style: "dashed",
            color: getCssVar("--color-background-default"),
            width: 1.5,
          },
        ]}
        style={{ width: MAIN_WIDTH, height: HEIGHT }}
      >
        <div className="flex h-full flex-col justify-center p-6 text-white" style={{ height: HEIGHT }}>
          <div className="text-xs font-semibold uppercase tracking-widest opacity-80">{label}</div>
          <div className="flex flex-col">
            <span className="font-poppins text-2xl font-semibold">{title}</span>
            <span className="text-xs opacity-80">{subtitle}</span>
          </div>
        </div>
      </VoucherCard>
      <VoucherCard
        fillColor="var(--color-background-primary-dark)"
        borderStyle="none"
        borderRadius={12}
        notches={[
          { position: { x: 0, y: 0 }, radius: NOTCH_RADIUS },
          { position: { x: 0, y: HEIGHT }, radius: NOTCH_RADIUS },
        ]}
        style={{ width: STUB_WIDTH, height: HEIGHT }}
      >
        <div className="flex items-center justify-center text-3xl font-bold text-white" style={{ height: HEIGHT }}>
          {stub}
        </div>
      </VoucherCard>
    </div>
  );
};

export default HeroVoucher;
